import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormGroup,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { withTranslation } from "react-i18next";
import { toggleRightSidebar } from "../../store/actions";

// Import logo Images
import logo from "../../assets/images/logo.png";
import ioc_logo from "../../assets/images/io-logo.svg";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

// react-hook-form
import { useForm, Controller } from "react-hook-form";
import { get, getCurrentAssignedNozzel, put } from "helpers/api_helper";
import {
  ASSIGN_NOZZEL,
  NOZZLE_LIST,
  UNASSIGN_NOZZEL,
  UPDATE_NOZZLE_STOCK,
} from "helpers/url_helper";

function Header({ toggleMenuCallback, toggleRightSidebar }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState(2)

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
      setRole(role)
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [nozzelModalOpen, setNozzelModalOpen] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [nozzels, setNozzels] = useState([]);
  const [assignedNozzelId, setAssignedNozzelId] = useState("");
  const [assignedNozzelULId, setAssignedNozzelULId] = useState("");

  const onSubmit = async (data) => {
    const payload = {
      ltr: data.fuelQty,
      ...(isAdmin ? {} : { nozzel_ul_id: data?.nozzel_ul_id }),
    };

    if (data.buying_price) {
      payload.buying_price = data.buying_price;
    }

    try {
      const response = await put(UPDATE_NOZZLE_STOCK, payload);
      console.log("Success Response:", response);
      const isAdminSuccess =
        isAdmin && response?.message?.toLowerCase().includes("updated");
      const isUserSuccess =
        !isAdmin && response?.message === "Ok" && !!response?.data;
      if (isAdminSuccess || isUserSuccess) {
        toastr.success(response.message || "Stock Added Successfully");
        reset();
        setModalOpen(false);
      } else {
        toastr.error(
          response?.message || "New stock cannot be greater than total capacity"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      toastr.error(errorMessage);
    }
  };

  const onNozzelSubmit = async (data) => {
    console.log("Assigned Nozzel :", data);

    const response = await put(ASSIGN_NOZZEL(data?.nozzel_ul_id), data);
    console.log(response);
    reset();
    setNozzelModalOpen(false);
  };

  const unAssignedNozzle = async () => {
    await get(UNASSIGN_NOZZEL(assignedNozzelULId));
    reset();
    setNozzelModalOpen(false);
  };

  useEffect(() => {
    // Fetch nozzles data from the API and set it in the form
    if (modalOpen || nozzelModalOpen) {
      const fetchNozzles = async () => {
        try {
          const response = await get(NOZZLE_LIST);
          const items =
            response?.data?.items.length > 0 ? response.data.items : [];

          setNozzels(items);
        } catch (error) {
          console.error("Error fetching nozzles:", error);
        }
      };
      const currentAssignedNozzel = async () => {
        try {
          const response = await getCurrentAssignedNozzel();
          if (response?.data?.vehicle_no) {
            setAssignedNozzelId(response.data.vehicle_no);
            setAssignedNozzelULId(response.data.ul_id);
            reset({
              nozzel_ul_id: response.data.ul_id,
            });
          } else {
            setAssignedNozzelId("");
          }
        } catch (error) {
          console.error("Error fetching assigned nozzle:", error);
        }
      };
      if (role === 2) {
        fetchNozzles();
        currentAssignedNozzel();
      }
    }
  }, [modalOpen, nozzelModalOpen]);

  const toggle = () => setModalOpen((prev) => !prev);

  const toggleNozzel = () => setNozzelModalOpen((prev) => !prev);

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <ProfileMenu />
            </div>

            <Button
              size="sm"
              color="none"
              type="button"
              onClick={toggleMenuCallback}
              className="px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="ri-menu-2-line align-middle"></i>
            </Button>
          </div>

          <div className="d-flex mob-size-logo">
            <div className="logo-lg d-flex align-items-center">
              <img src={ioc_logo} alt="" height="50" />
              <h2 className="m-0 mx-2 h4">NAMASHKAR FUEL</h2>
              <img src={logo} alt="" height="50" />
            </div>
          </div>

          <div className="d-flex">
            <div className="dropdown ms-1 center-items m-auto ">
              <Link
                className="waves-effect btn btn-info btn-sm"
                onClick={toggle}
              >
                Add stock
              </Link>

              <Link
                className="waves-effect btn btn-info ms-2 Assign Nozzel  btn-sm"
                onClick={toggleNozzel}
              >
                Assign Nozzel
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Modal Section */}
      <Modal isOpen={modalOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Add Fuel Stock</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Label for="fuelQty">Quantity (liters)</Label>
              <Controller
                name="fuelQty"
                control={control}
                rules={{
                  required: "Fuel Quantity is required",
                  pattern: {
                    value: /^[0-9.]+$/,
                    message: "Please enter a valid number",
                  },
                  min: {
                    value: 10,
                    message: "Must be at least 10",
                  },
                  max: {
                    value: 50000,
                    message: "Must be 50000 or less",
                  },
                }}
                render={({ field }) => (
                  <Input
                    id="fuelQty"
                    {...field}
                    type="text"
                    inputMode="numeric"
                    maxLength={8}
                    pattern="[0-9.]*"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
                        field.onChange(value);
                      }
                    }}
                  />
                )}
              />
              {errors.fuelQty && (
                <span className="text-danger">{errors.fuelQty.message}</span>
              )}
            </FormGroup>
            {isAdmin && (
              <FormGroup>
                <Label for="fuelType">Buying price</Label>
                <Controller
                  name="buying_price"
                  control={control}
                  render={({ field }) => (
                    <Input
                      id="buying_price"
                      {...field}
                      type="text"
                      inputMode="numeric"
                      maxLength={8}
                      pattern="[0-9.]*"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
                          field.onChange(value);
                        }
                      }}
                    />
                  )}
                />
              </FormGroup>
            )}
            {!isAdmin && (
              <FormGroup>
                <Label for="fuelType">Select Nozzle</Label>
                <Controller
                  name="nozzel_ul_id"
                  control={control}
                  rules={{ required: "Nozzel is required" }}
                  render={({ field }) => (
                    <Input id="nozzel_ul_id" {...field} type="select">
                      <option value="">Select Nozzle</option>
                      {nozzels.map((option) => (
                        <option
                          key={option.ul_id}
                          value={option.ul_id}
                          selected={assignedNozzelId === option.vehicle_no}
                        >
                          {option.vehicle_no}
                        </option>
                      ))}
                    </Input>
                  )}
                />
                {errors.nozzel_ul_id && (
                  <span className="text-danger">
                    {errors.nozzel_ul_id.message}
                  </span>
                )}
              </FormGroup>
            )}

            <ModalFooter>
              <Button color="primary" type="submit">
                Submit
              </Button>
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={nozzelModalOpen} toggle={toggleNozzel}>
        <ModalHeader toggle={toggleNozzel}>Assign Nozzel</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(onNozzelSubmit)}>
            <p>
              current assigned nozzel:{" "}
              {assignedNozzelId ? assignedNozzelId : "None"}
            </p>
            <FormGroup>
              <Label for="fuelType">Select Nozzel</Label>
              <Controller
                name="nozzel_ul_id"
                control={control}
                rules={{ required: "Nozzel is required" }}
                render={({ field }) => (
                  <Input id="nozzel_ul_id" {...field} type="select">
                    <option value="">Select Nozzel</option>
                    {nozzels.map((option) => (
                      <option
                        key={option.ul_id}
                        value={option.ul_id}
                        selected={assignedNozzelId === option.vehicle_no}
                      >
                        {option.vehicle_no}
                      </option>
                    ))}
                  </Input>
                )}
              />
              {errors.nozzel_ul_id && (
                <span className="text-danger">
                  {errors.nozzel_ul_id.message}
                </span>
              )}
            </FormGroup>

            <ModalFooter>
              {assignedNozzelId && (
                <Button color="primary" onClick={unAssignedNozzle}>
                  Unassigned Current Nozzel
                </Button>
              )}
              <Button color="primary" type="submit">
                Submit
              </Button>
              <Button color="secondary" onClick={toggleNozzel}>
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}

export default connect(null, { toggleRightSidebar })(withTranslation()(Header));
